import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CORGI_FRAME_RELAUNCH = createFcmConfig('corgi_frame_relaunch', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
